// extracted by mini-css-extract-plugin
module.exports = {"headerImageFrame":"A1","headerImage":"A2"};